export const RECAPTCHA_PUBLIC_KEY = import.meta.env.VITE_RECAPTCHA_PUBLIC_KEY || "6LcHGc8qAAAAAICnZMKeae768nsFQKnB3x42177M";
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "";
// Debug configuration
export const DEBUG = import.meta.env.DEV;

// Domain configuration
export const BASE_DOMAIN = DEBUG ? 'localhost' : '.relightsa.co.za';
export const DOMAIN = DEBUG ? 'localhost' : 'www.relightsa.co.za';
const isLocalHost = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);
const localApiBaseUrl = typeof window !== 'undefined' ? `${window.location.protocol}//${window.location.hostname}:8082` : 'http://127.0.0.1:8082';
export const BASE_URL = isLocalHost ? (import.meta.env.VITE_API_BASE_URL || localApiBaseUrl) : window.location.origin;
